import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookies_choice')) {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem('cookies_choice', value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: '#fff',
      borderTop: '1px solid #e5e5e5',
      padding: '16px clamp(16px, 4vw, 32px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '24px',
      boxShadow: '0 -4px 16px rgba(0,0,0,0.08)',
      flexWrap: 'wrap',
    }}>
      <p style={{
        fontFamily: 'Jane Light, sans-serif',
        fontSize: '13px',
        color: '#4A4A4A',
        margin: 0,
        flex: 1,
        minWidth: '260px',
      }}>
        Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre{' '}
        <a href="/politique-cookies" style={{ color: '#C10230', fontWeight: '600', textDecoration: 'none' }}>
          politique de cookies
        </a>.
      </p>

      <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
        <button
          onClick={() => choose('refused')}
          style={{
            fontFamily: 'Jane Light, sans-serif',
            fontSize: '13px',
            fontWeight: '600',
            color: '#4A4A4A',
            backgroundColor: '#fff',
            border: '1.5px solid #d0d0d0',
            borderRadius: '8px',
            padding: '10px 20px',
            cursor: 'pointer',
          }}
        >
          Refuser
        </button>
        <button
          onClick={() => choose('accepted')}
          style={{
            fontFamily: 'Jane Light, sans-serif',
            fontSize: '13px',
            fontWeight: '600',
            color: '#fff',
            backgroundColor: '#C10230',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 20px',
            cursor: 'pointer',
          }}
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
